module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container header"
  }, [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "125px",
      "height": "72px"
    },
    attrs: {
      "src": "/static/img/logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('ul', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "mouseover": function($event) {
          return _vm.addClass($event)
        },
        "mouseleave": function($event) {
          return _vm.rmClass($event)
        },
        "click": function($event) {
          return _vm.toLink(item.link, $event)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.text) + "\n                        "), (index == 2) ? _c('div', {
      staticClass: "dropdown-menu"
    }, [_c('div', {
      staticClass: "dropdown-menu-item",
      on: {
        "click": function($event) {
          return _vm.jump('/ac1')
        }
      }
    }, [_vm._v("4G打印机")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu-item",
      on: {
        "click": function($event) {
          return _vm.jump('/ac2')
        }
      }
    }, [_vm._v("WiFi+USB")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu-item",
      on: {
        "click": function($event) {
          return _vm.jump('/ac3')
        }
      }
    }, [_vm._v("蓝牙+USB")]), _vm._v(" "), (index == 2) ? _c('div', {
      staticClass: "dropdown-menu-item"
    }) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.gotoBackend($event)
      }
    }
  }, [_c('div', {
    staticClass: "navbar-button"
  }, [_vm._v("管理后台")])])], 2)])], 1)]), _vm._v(" "), (_vm.showService) ? _c('div', {
    staticClass: "cndns-right"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-meau meau-top",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "top-back"
    }
  }, [_c('a', {
    staticClass: "cndns-right-btn backtop",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.topBack()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "35px"
    }
  }, [_vm._v("^")]), _vm._v(" "), _c('i', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("顶部")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cndns-right-meau meau-sev"
  }, [_c('a', {
    staticClass: "cndns-right-btn",
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "demo-icon"
  }), _vm._v(" "), _c('p', [_vm._v("\n                    在线\n                    "), _c('br'), _vm._v("客服\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-box"
  }, [_c('div', {
    staticClass: "box-border"
  }, [_c('div', {
    staticClass: "clearfix sev-t"
  }, [_c('span', {
    staticClass: "demo-icon"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                            在线客服\n                            "), _c('i', [_vm._v("服务时间：周一至周日 09:00～20:00")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix sev-b"
  }, [_c('h4', [_vm._v("选择下列服务马上在线沟通：")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "zixunUl"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("销售经理")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("市场合作")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("技术支持")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("售后客服")])])])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cndns-right-meau meau-contact"
  }, [_c('a', {
    staticClass: "cndns-right-btn",
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "demo-icon t2"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/t2.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                    客服\n                    "), _c('br'), _vm._v("热线\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-box"
  }, [_c('div', {
    staticClass: "box-border"
  }, [_c('div', {
    staticClass: "clearfix sev-t"
  }, [_c('p', [_vm._v("\n                            13600093009\n                            "), _c('br'), _vm._v(" "), _c('i', [_vm._v("服务时间：周一至周日 09:00～20:00")])])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cndns-right-meau meau-code"
  }, [_c('a', {
    staticClass: "cndns-right-btn",
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "demo-icon t3"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/t3.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                    关注\n                    "), _c('br'), _vm._v("微信\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-box"
  }, [_c('div', {
    staticClass: "box-border clearfix"
  }, [_c('div', {
    staticClass: "sev-t"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wx.jpg"
    }
  }), _vm._v(" "), _c('i', [_vm._v("关注微信公众号")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b98b6cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topHeader.vue
// module id = 339
// module chunks = 1